import { render, staticRenderFns } from "./PodtEditGold.vue?vue&type=template&id=5aa77bfa&scoped=true&"
import script from "./PodtEditGold.vue?vue&type=script&lang=js&"
export * from "./PodtEditGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa77bfa",
  null
  
)

export default component.exports